import { HttpErrorResponse } from '@angular/common/http';

export class NotAcceptableError extends Error {
    httpStatus = 406;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, NotAcceptableError.prototype);
    }
}
